/** Props of the panel a tab controls: pass the same `id` to `Tabs` and spread this on the content. */
export function tabPanel(id: string, value: string) {
  return { role: 'tabpanel', id: `${id}-panel`, 'aria-labelledby': `${id}-tab-${value}`, tabIndex: 0 } as const;
}
